import * as React from "react";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import { Navigate } from "react-router";
import { AuthenticationView } from "./authentication";

export const LoginView: React.FC = () => {
  const user = useAuthenticatedUser();

  if (user.isAuthenticated) {
    return <Navigate to={"/"} />;
  }

  return <AuthenticationView />;
};
